import { z } from 'zod';
import { isAdjustmentLineType } from '../../../sales-order-lines/adjustment-line-types.js';
import { nullableUuidString } from '../../zod-helpers/index.js';
import { MAX_ADJUSTMENT_LINES } from './max-adjustment-lines.js';
import { salesOrderAdjustmentDiscountTypeSchema } from './sales-order-adjustment-discount-type-schema.js';
// The adjustments entry's shape without its write rules: it echoes what is stored, which an older order may hold outside them.
const salesOrderExpectedAdjustmentLineSchema = z
    .object({
    typeId: z
        .number()
        .refine((value) => isAdjustmentLineType(value), { message: 'Invalid adjustment line type.' }),
    amount: z.number().optional(),
    percent: z.number().optional(),
    discountType: salesOrderAdjustmentDiscountTypeSchema.optional(),
    taxRateId: nullableUuidString('Invalid tax rate selection.').optional(),
})
    .strict();
/** #336 B7: the adjustment set the editor loaded; updateSalesOrder refuses `adjustments` when the stored set no longer matches it. */
export const salesOrderExpectedAdjustmentsSchema = z
    .array(salesOrderExpectedAdjustmentLineSchema)
    .max(MAX_ADJUSTMENT_LINES, 'Too many adjustments.');
//# sourceMappingURL=sales-order-expected-adjustments-schema.js.map